import { Panel } from 'components/Panel';
import { useContext } from 'react';
import { AuthContext } from 'auth/AuthContextProvider';
import { useQuery } from 'react-query';
import { Center } from '@chakra-ui/react';
import { Chart } from 'react-google-charts';

import { FilterDefinition, GenerateFilterQuery } from '../StatFilter';
import { StatError, StatLoading, StatNoData } from '../StatSharedElement';

export type Props = {
  label: string;
  targetQuery: string;
  sortByValue?: boolean;
  filterDefinition?: FilterDefinition;
};

type KeyValue = {
  key: string;
  value: number;
};
export const StatPanelPieChart = ({
  label,
  targetQuery,
  sortByValue = false,
  filterDefinition,
}: Props) => {
  const { token } = useContext(AuthContext);

  const Query = '/API/stats/' + targetQuery + GenerateFilterQuery(filterDefinition);
  const { isLoading, error, data } = useQuery(
    'get' + Query,
    () =>
      fetch(Query, {
        method: 'GET',
        headers: new Headers({
          Authorization: token,
        }),
      }).then((res) => res.json()),
    { refetchOnWindowFocus: false },
  );

  let componentsToSHow = <></>;
  if (isLoading) {
    componentsToSHow = StatLoading;
  }

  if (error) {
    componentsToSHow = StatError;
  }

  let chartData: (string | number)[][] = [['Type', 'Nombre']];

  if (data) {
    if (data.list.length > 0) {
      if (sortByValue) {
        data.list.sort((a: KeyValue, b: KeyValue) => (a.value < b.value ? 1 : -1));
      } else {
        data.list.sort((a: KeyValue, b: KeyValue) => (a.key < b.key ? -1 : 1));
      }
      data.list.forEach(function (value: any) {
        chartData = chartData.concat([[value.key == null ? 'NC' : value.key, value.value]]);
      });
      componentsToSHow = (
        <Chart
          chartType="PieChart"
          options={{
            pieHole: 0.4,
            height: 260,
            width: 300,
            colors: ['#31A0A1', '#FCB630', '#D58500', '#F4D560', '#1A3742', '#09535E'],
            chartArea: { left: '10%', top: '5%', width: '90%', height: '90%' },
            //legend: { position: 'top' },
          }}
          data={chartData}
        />
      );
    } else {
      componentsToSHow = StatNoData;
    }
  }

  return (
    <Panel
      height="300px"
      position="relative"
      width="300px"
      float={'left'}
      margin={{ base: '10px' }}
      py={'10px'}
    >
      <Center as="b" fontSize={'15px'}>
        {label}
      </Center>
      {componentsToSHow}
    </Panel>
  );
};
